import http from "./http.config";
import { type ApiEnvelope, unwrapApiResponse } from "./api.utils";

export type InquiryTimelineState = "done" | "active" | "pending";

export type InquiryQuote = {
  id: number | string;
  quote_no: string;
  vendor_name: string;
  price: string;
  date: string;
  status: string;
};

export type InquiryAttachment = {
  url: string;
  description: string;
};

export type InquiryResponseItem = {
  label: string;
  value: string;
};

export type InquiryTimelineItem = {
  title: string;
  time: string;
  state: InquiryTimelineState;
};

export type InquiryService = {
  category_name: string;
  name: string;
  priority: "Urgent" | "Normal" | string;
  description: string;
  schedule_label: string;
};

export type InquiryClient = {
  name: string;
  phone: string;
  avatar: string;
  email: string;
};

export type InquiryServiceArea = {
  address_line: string;
  city: string;
  state: string;
  zip: string;
};

export type InquiryVendor = {
  id: number | string;
  name: string;
  vendor_code?: string | null;
  company_name?: string | null;
  phone?: string | null;
  address?: string | null;
};

export type InquiryDetail = {
  id: number;
  type: string;
  inquiry_no: string;
  created_at: string;
  service: InquiryService;
  client: InquiryClient;
  service_area: InquiryServiceArea;
  vendor?: InquiryVendor | null;
  quotes: InquiryQuote[];
  attachments: InquiryAttachment[];
  responses: InquiryResponseItem[];
  timeline: InquiryTimelineItem[];
  description?: string | null;
  status: string;
};

export const fetchInquiries = (params = {}) =>
	http.get("/inquiries/list", { params }).then((res) => res.data);

export const fetchVendorInquiries = (params = {}) =>
	http.get("/vendors/inquiries", { params }).then((res) => res.data);

export const fetchVendorInquiryDetails = (id: string | number, params = {}) =>
  http
    .get<InquiryDetail | ApiEnvelope<InquiryDetail>>(`/vendors/inquiries/${id}/details`, { params })
    .then((res) => unwrapApiResponse(res.data));

export const fetchCustomerInquiries = (params = {}) =>
	http.get("/customers/inquiries", { params }).then((res) => res.data);

export const fetchCustomerInquiryDetails = (id: string | number, params = {}) =>
  http
    .get<InquiryDetail | ApiEnvelope<InquiryDetail>>(`/customers/inquiries/${id}/details`, { params })
    .then((res) => unwrapApiResponse(res.data));

export const fetchInquiryById = (id: string | number, params = {}) =>
  http
    .get<InquiryDetail | ApiEnvelope<InquiryDetail>>(`/inquiries/${id}`, { params })
    .then((res) => unwrapApiResponse(res.data));

export const storeInquiry = (payload = {}) =>
  http.post("/inquiries/store", payload).then((res) => res.data);
